import { JSXElementConstructor, ReactElement } from 'react';

import { Modal as MuiModal, Backdrop, Fade, Box } from '@mui/material';

const BoxContainerStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '16px',
  boxShadow: (theme: any) =>
    theme.palette.mode === 'dark'
      ? '0 8px 32px rgba(0, 0, 0, 0.6), 0 2px 8px rgba(0, 0, 0, 0.4)'
      : '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
  p: 4,
  backdropFilter: 'blur(0px)', // Remove blur for solid appearance
  // Remove overflow: scroll - let content dictate scrolling
};

type ModalProps = {
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  open: boolean;
  onClose?: () => void;
  modalWidth?: number;
  modalMaxHeight?: number;
  modalHeight?: number;
};

const Modal = (props: ModalProps) => {
  const { children, open, onClose, modalWidth = 600, modalMaxHeight = 600, modalHeight } = props;

  return (
    <MuiModal
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)',
        },
      }}
      open={open}
      onClose={onClose}
    >
      <Fade in={open}>
        <Box
          sx={{
            ...BoxContainerStyle,
            width: modalWidth,
            maxHeight: modalMaxHeight,
            height: modalHeight,
            overflowY: modalHeight ? 'auto' : 'visible',
            overflowX: 'hidden',
            // Ensure solid background
            backgroundColor: (theme) => theme.palette.background.paper,
            // Hide scrollbar for better appearance
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
              },
            },
          }}
        >
          {children}
        </Box>
      </Fade>
    </MuiModal>
  );
};

export default Modal;
